import { useState } from 'react';
import { CheckoutForm } from '../ui/CheckoutForm';
import { SubscriptionCheckoutProvider } from './SubscriptionCheckoutProvider';
import { Box } from '@/components/Box/Box';
import { CheckoutLoaderWrapper } from '../styles';
import { LayoutSpinner } from '@/bundle/Layouts/styles';
import { UNEXPECTED_ERROR_MESSAGE } from '@/const/shared';
import { Notification } from '@/components/Notification/Notification';
import { useCatchStripeInitError } from '../useCatchStripeInitError';

type SubscriptionCheckoutWidgetType = {
  planId: string;
  onSuccess: () => void;
};

export const SubscriptionCheckoutWidget = ({ planId, onSuccess }: SubscriptionCheckoutWidgetType) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useCatchStripeInitError((error) => {
    setError(error);
    setLoading(false);
  });

  const errorHandler = () => {
    setLoading(false);
    setError(UNEXPECTED_ERROR_MESSAGE);
  };

  return (
    <Box position='relative' height='100%'>
      {error && (
        <Notification variant='error' marginBottom='16px'>
          {error}
        </Notification>
      )}
      <SubscriptionCheckoutProvider planId={planId} onError={errorHandler}>
        <CheckoutForm
          paymentType='subscription'
          loading={loading}
          onLoadingEnd={() => setLoading(false)}
          onSuccess={onSuccess}
        />
      </SubscriptionCheckoutProvider>

      {loading && (
        <CheckoutLoaderWrapper>
          <LayoutSpinner />
        </CheckoutLoaderWrapper>
      )}
    </Box>
  );
};
